<template>
  <div id="app">
      <router-view/>
  </div>
</template>


<script>
  import Main from './layouts/Main';

  export default {
    components: Main
  }
</script>

<style>
  @import url('static/css/icomoon.css');
  @import url('../cover/vendors/flatpickr/style.css');
</style>